import { GetTodayPunchTime } from "../AttendanceApis";

const formatTime = (raw) => {
    if (!raw) return "N/A";
    const timePart = String(raw).split(".")[0];
    const [hStr, mStr] = timePart.split(":");
    if (hStr === undefined || mStr === undefined) return raw;
    const h = parseInt(hStr, 10);
    const m = mStr.padStart(2, "0");
    const period = h >= 12 ? "PM" : "AM";
    const h12 = h % 12 === 0 ? 12 : h % 12;
    return `${String(h12).padStart(2, "0")}:${m} ${period}`;
};

const formatDate = (raw) => {
    if (!raw) return "N/A";
    const d = new Date(raw);
    if (isNaN(d)) return raw;
    return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

const formatStatusLabel = (status) => {
    const key = status?.toLowerCase();
    const statusMap = {
        present: "Present",
        absent: "Absent",
        late: "Late",
    };
    return statusMap[key] ?? status ?? "N/A";
};

export const VIEW_ATTENDANCE_OUTER_COLUMNS = [
    "S.No",
    "Emp Code",
    "Employee Name",
    "Designation",
    "Department",
    "Master Shift",
    "Actual Shift",
    "Zone",
    "Ward",
    "KPI Category",
    "Device ID",
    "Date",
    "Punch In",
    "Punch Out",
    "Total Time",
    "Status",
];

export const VIEW_ATTENDANCE_INNER_COLUMNS = ["S.No", "Emp Code", "Punch Time"];

export const getViewAttendanceEmployeeKey = (row) =>
    String(row?.employeeId ?? row?.EmployeeId ?? row?.employeeCode ?? "");

export const mapViewAttendanceOuterRowsForExport = (attendanceData = []) =>
    attendanceData.map((row, index) => [
        index + 1,
        row.employeeCode ?? row.empCode ?? row.empId ?? "N/A",
        row.employeeName ?? "N/A",
        row.designationName ?? row.designation ?? "N/A",
        row.departmentName ?? row.department ?? "N/A",
        row.masterShift ?? "N/A",
        row.actualShift ?? "N/A",
        row.zoneName ?? "N/A",
        row.circleName ?? row.wardName ?? row.wardNo ?? "N/A",
        row.kpiCategoryName ?? row.kpiCategory ?? "N/A",
        row.deviceId ?? "N/A",
        formatDate(row.date),
        formatTime(row.punchIn),
        formatTime(row.punchOut),
        row.totalTime ?? "N/A",
        formatStatusLabel(row.status ?? row.Status),
    ]);

export const mapPunchRowsForExport = (punches = []) =>
    punches.map((punch, index) => [
        punch.sNo ?? index + 1,
        punch.empCode ?? "N/A",
        formatTime(punch.punchTime),
    ]);

export const getPunchHistoryForRow = (row, punchHistoryByEmployeeId = {}) => {
    const employeeKey = getViewAttendanceEmployeeKey(row);
    if (!employeeKey) return [];
    return punchHistoryByEmployeeId[employeeKey] ?? [];
};

export const loadAllPunchHistory = async (attendanceData = []) => {
    const punchHistoryByEmployeeId = {};

    await Promise.all(
        attendanceData.map(async (row) => {
            const employeeKey = getViewAttendanceEmployeeKey(row);
            if (!employeeKey || !row.employeeId) return;

            try {
                const response = await GetTodayPunchTime(row.employeeId);
                punchHistoryByEmployeeId[employeeKey] = response?.data ?? [];
            } catch {
                punchHistoryByEmployeeId[employeeKey] = [];
            }
        })
    );

    return punchHistoryByEmployeeId;
};

export const getViewAttendanceExportDateTime = (reportTitle = "View Attendance Report") => {
    const now = new Date();
    const date = `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}`;
    const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
    return `${reportTitle} Generated on: ${date}, ${time}`;
};
